import core_viz from './core-viz';
import landing from './landing';
import track from './track';
import love_hate from './love-hate';
import util from './_utils';

const love_hate_panel = d3.select('.graphic__right.love-hate');

let drawn = false,
	init_timeout = null,
	restart_timeout = null,
	skip_timeout = null,
	button_timeout = null;

function init() {
	util.changeVisibility(['.graphic__right.love-hate', '.intro-step', '.bottom-ui'], [true, false, false]);
	util.changeHeader('.landing-header', '.main-header');

	if (!drawn) {
		d3.selectAll('.intro-step').classed('is-past', true);

		init_timeout = setTimeout(() => {
			util.changeVisibility(['.lh__step--lh-1'], [true], [love_hate_panel]);
		}, 250);

		d3.selectAll('.lh-button__next').on('click', next);
	}

	drawn = true;
}

function restart() {
	core_viz.moveMass('outOfView', false);

	util.changeVisibility(['.graphic__right', '.graphic__right.love-hate', '.skip-intro'], [false, true, true]);

	if (!drawn) init();

	jumpTo(1, true);
}

function next() {
	const el = d3.select(this),
		index = +el.attr('data-index');

	if (index != 4) {
		track.next(index);
		love_hate.next(index);

		love_hate_panel.select(`[data-step='${index}']`).classed('is-past', true);
		util.changeVisibility([`[data-step='${index}']`, `[data-step='${index + 1}']`], [false, true], [love_hate_panel, love_hate_panel]);

		const stop = love_hate_panel.select(`[data-step='${index + 1}']`).attr('data-stop');
	} else {
		landing.end();
		$('.graphic').unbind('scroll');
		$('.graphic').unbind('mousewheel');
	}
}

function end() {
	$('.graphic').unbind('scroll');
	$('.graphic').unbind('mousewheel');
	d3.selectAll('.lh-step').classed('is-past', false).classed('is-visible', false);
	d3.selectAll('.intro-step').classed('is-past', false).classed('is-visible', false);
	drawn = false;
}

function jumpTo(index, fromMenu = false) {
	for (let i = 0; i < index; i++) {
		love_hate_panel.select(`[data-step='${i}']`).classed('is-past', true).classed('is-visible', false);
	}

	for (let i = index; i < 11; i++) {
		love_hate_panel.select(`[data-step='${i}']`).classed('is-past', false).classed('is-visible', false);
	}

	// buttonDelay(5000);
	util.changeVisibility([`[data-step='${index}']`], [true], [love_hate_panel]);
	love_hate.next(index - 1, fromMenu);
}

function skip(index) {
	const stop = love_hate_panel.select(`[data-step='${index + 1}']`).attr('data-stop');

	buttonDelay(5000);

	skip_timeout = setTimeout(function() {
		love_hate_panel.select(`[data-step='${index}']`).classed('is-past', true);
		util.changeVisibility([`[data-step='${index}']`, `[data-step='${index + 1}']`], [false, true], [love_hate_panel, love_hate_panel]);

		track.next(index);
		love_hate.next(index);

		if (stop == 'false') {
			// skip(index + 1);
		}
	}, 5000)
}

function buttonDelay(dur) {
	d3.selectAll('.progress, .header-button-personalize, .skip-intro').style('pointer-events', 'none')

	button_timeout = setTimeout(() => {
		d3.selectAll('.progress, .header-button-personalize, .skip-intro').style('pointer-events', 'all');
	}, dur)

}

function clear() {
	if (init_timeout) clearTimeout(init_timeout);
	if (restart_timeout) clearTimeout(restart_timeout);
	if (skip_timeout) clearTimeout(skip_timeout);
	if (button_timeout) clearTimeout(button_timeout);
}

export default {
	init,
	jumpTo,
	restart,
	clear,
	end
};